import { twMerge } from 'tailwind-merge';
import type { HtmlElementProps } from '@/types';
import { classes } from './utils';

export interface BaseMenuItemProps extends HtmlElementProps<HTMLLIElement> {}

export default function BaseMenuItem({
  className,
  ...props
}: BaseMenuItemProps) {
  return <li className={twMerge(classes.item, className)} {...props} />;
}
